<template>
  <div class="login-page">
    <footer>
      <p class="first-line">
        {{ msg }}
      </p>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: ""
    };
  },
  created() {
    let _this = this;
    let url = this.$route.query.url;
    if (url !== null && url !== undefined && url !== "") {
      if(url.indexOf('XY8x6g7bztk') != -1){
        window.location.href = 'weixin://dl/business/?t=XY8x6g7bztk'
      }else {
        window.location.href = url;
      }
      
    } else {
      _this.msg = "您拍的二维码不是海尔最新码制!";
    }
  }
};
</script>
<style lang="sass" scoped>
footer
    .first-line, .second-line
        text-align: center
        font-size: 14px

    .first-line
        padding-top: 100px
        color: rgb(149, 149, 149)
        margin-bottom: 5px
</style>
